<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Report Outstanding PT Session</div>
        <div class="box-mini mb-10">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-4">
                <table>
                  <tr>
                    <td>
                      <a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                    </td>
                    <td>
                      <div class="col-sm-12">
                        <input
                          type="month"
                          class="form-control"
                          name="event_date"
                          min="2000-01"
                          v-model="dateTodayData"
                          @change="changeDate"
                        />
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-md-3">
              </div>
              <div class="col-sm-5 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input
                        type="text"
                        @keyup.enter="enterClicked(searchData)"
                        v-model="searchData"
                        class="form-control"
                        placeholder="Search"
                      />
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0" />
          <div class="p-15">
            <b-table
              @sort-changed="sortingChanged"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :items="items"
              :fields="fields"
              class="table-fixedwidth text-center"
            >
              <template v-slot:cell(receipt_date)="data">{{dateFormat(data.item.receipt_date)}}</template>
              <template v-slot:cell(action)="data">
                <b-button
                  size="sm"
                  @click="openPage('/settlement/edit?id=' + data.item.id)"
                  class="btn-table warning mr-5"
                >
                  <i class="fas fa-pen font-12 mr-5"></i>Edit
                </b-button>
                <b-button
                  size="sm"
                  @click="openPage('/settlement/submit?receipt_date=' + data.item.receipt_date)"
                  class="btn-table green"
                >
                  <i class="fas fa-eye font-12 mr-5"></i>Detail
                </b-button>
              </template>
            </b-table>
            <app-pagination
              class="pagination-custom mt-20"
              :current-page="currentPage"
              :total-pages="totalPage"
              @page-changed="pageOneChanged"
              prev-text="Prev"
              next-text="Next"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  tr {
    th {
      background-color: #2F353A;
      color: white;
    }
  }
</style>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";

export default {
  name: "keysoftHistory",
  components: {
    "app-pagination": Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      fields: [
        {
          key: "trx_id",
          label: "Transaction ID",
          sortable: false
        },
        {
          key: "name",
          label: "Name",
          sortable: false
        },
        {
          key: "phone",
          label: "Phone Number",
          sortable: false
        },
        {
          key: "membership_type",
          label: "Membership Type",
          sortable: false
        },
        {
          key: "membership_status",
          label: "Membership Status",
          sortable: false
        },
        {
          key: "pt_session",
          label: "PT Session",
          sortable: false
        },
        {
          key: "price_per_session",
          label: "Satuan Session",
          formatter: (value, key, item) => {
            return 'Rp. ' + parseInt(value).toLocaleString('id-ID', {maximumFractionDigits:0})
          },
          sortable: false
        },
        {
          key: "current_session_qty",
          label: "Revenue Session",
          formatter: (value, key, item) => {
            return 'Rp. ' + parseInt(value * item.price_per_session).toLocaleString('id-ID', {maximumFractionDigits:0})
          },
          sortable: false
        },
        {
          key: "created_at",
          label: "Period Month",
          formatter: (value, key, item) => {
            return moment(value).format('DD MMMM YYYY')
          },
          sortable: false
        },
        {
          key: "date",
          label: "PT Session Expired",
          formatter: (value, key, item) => {
            return moment(value).format('DD MMMM YYYY')
          },
          sortable: false
        },
        {
          key: "personal_training",
          label: "Personal Training",
          sortable: false
        },
        {
          key: "branch.name",
          label: "Branch",
          sortable: false
        },
      ],
      dateTodayData: moment(new Date()).format("YYYY-MM"),
      past_member_date: moment(new Date()).add(-1, 'M').format("YYYY-MM"),
      dateWeek: "",
      items: [],
      sortType: "",
      sortBy: "",
      searchData: "",
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      memberPast: []
    };
  },
  methods: {
    exportReport() {
       let url = 'fitness/v1/export/report_outstanding/pt_session?date='+this.past_member_date
        axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Outstanding PT Session Report '+moment(this.past_member_date).startOf('month').format('DD MMM YYYY')+' - '+moment(this.past_member_date).endOf('month').format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
      console.log(this.dateTodayData)
    },
    changeDate(event) {
      console.log(event)
      this.past_member_date = this.dateTodayData
      this.fetchData();
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    sortingChanged(event) {
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
      } else {
        this.sortType = "desc";
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      console.log(searchEvent)
      this.fetchData();
    },
    openPage(event) {
      this.$router.push(event);
    },
    async fetchData() {
      // let response = await axios.get('transaction/v1/keysoft_revenue?' + 'page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData);
      // this.items = response.data.data.rows;
      // this.totalPage = response.data.meta.pageCount;

      // get member past
        axios.get("fitness/v1/pt_planner_member_past?date=" +this.past_member_date + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&keyword=' + this.searchData).then((response) => {
          const past_data = response.data.data.rows
          this.totalPage = response.data.meta.pageCount;
          this.items = past_data
          // this.totalPage = past_data
          console.log(past_data)
        }).catch((error) => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
